"use strict";

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = void 0;

function getLabel(a, b) {
  var c = b.upperCaseLabels;
  return "string" == typeof a && c ? a.toUpperCase() : a;
}

var _default = getLabel;
exports["default"] = _default;